import cookies from "js-cookie";
import { WenJuanUrl } from "config/config";

const host = window.location.hostname;
const isTest =
  host === "test-front-base.survey.work" ||
  host === "test.front.base.survey.work" ||
  host === "localhost";
const parmas = cookies.get("shorcuts")
  ? `?token=${cookies.get("shorcuts")}`
  : "";
// 代替工作台地址
// 工作台路由 user/workbench/home
// export const loginAfterUrl = isTest
//   ? `http://testcloud.treeyee.com/entrance${parmas}`
//   : `https://wj.survey.work/entrance${parmas}`;
export const loginAfterUrl = oParmas => {
  // const url = isTest
  //   ? `http://testcloud.treeyee.com/entrance${oParmas || parmas}`
  //   : `https://wj.survey.work/entrance${oParmas || parmas}`;
  const url = `${WenJuanUrl[process.env.REACT_APP_CURRENT]}${oParmas ||
    parmas}`;
  return url;
};
